import { collection, doc, addDoc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "@freetech/models/db";
import { DateTime } from "luxon";
import { CreateCardParams } from "types/freelo/crud";
import { generateHumanReadableCardId } from "core/freelo/utils/generateHumanReadableCardId";
import { List } from "@freetech/models/freelo";
import { useSnackbar } from "@/hooks/common/useSnackbar";

export const createCard = async (params: CreateCardParams, userId: string): Promise<string> => {
  const {
    boardId,
    listId,
    title,
    description,
    assignee,
    reporter,
    additionalAssignees,
    labels,
    dueDate,
    startDate,
    comments,
  } = params;

  const listRef = doc(db.lists(boardId), listId);
  const listDoc = await getDoc(listRef);
  if (!listDoc.exists()) {
    throw new Error("List not found");
  }
  const list = listDoc.data() as List;

  const cardsCollectionRef = db.cards(boardId);
  const humanReadableId = await generateHumanReadableCardId(boardId);

  const newCardRef = await addDoc(cardsCollectionRef, {
    id: "",
    title: title || "Unknown Title",
    humanReadableId,
    listId,
    description: description || "",
    assignee: assignee || "",
    reporter: reporter || "",
    additionalAssignees: additionalAssignees || [],
    labels: labels || [],
    dueDate: dueDate || null,
    startDate: startDate || null,
    comments: comments || [],
    createdAt: DateTime.now().toISO(),
    updatedAt: DateTime.now().toISO(),
    createdBy: userId,
    archived: false,
    boardId: boardId, 
  });

  const currentCardOrder = list.cardOrder || [];

  const updatedCardOrder = [...currentCardOrder, newCardRef.id];

  await updateDoc(listRef, {
    cardOrder: updatedCardOrder,
    updatedAt: DateTime.now().toISO(),
  });

  return newCardRef.id;
};
